/** Viewport max-height (px) at which the onboarding modal uses a pinned action footer. */
export const MAIN_MODAL_COMPACT_MAX_HEIGHT_PX = 672;

/** Viewport max-width (px) at which narrow-screen copy applies (theme `sm` − 1). */
export const MAIN_MODAL_SMALL_SCREEN_MAX_WIDTH_PX = 575;

/** Top padding for the shared compact action shell (see {@link OnboardingModalActions}). */
export const MAIN_MODAL_COMPACT_ACTIONS_PADDING_TOP = '10px';

export const mainModalCompactHeightMediaQuery = `(max-height: ${ MAIN_MODAL_COMPACT_MAX_HEIGHT_PX }px)`;

export const mainModalSmallScreenMediaQuery = `(max-width: ${ MAIN_MODAL_SMALL_SCREEN_MAX_WIDTH_PX }px)`;
